/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetCopyRequest} from '@cash-web/protos/squareup/consentsys/service.pb'
import {GetCopyResponse} from '@cash-web/protos/squareup/consentsys/service.pb'


export const getCopy = (request: GetCopyRequest, options?: CashRequestOptions) => post<GetCopyRequest, GetCopyResponse>("/2.0/cash/get-copy", request, {...options, rejectOnError: true })